import {match, Pattern} from 'ts-pattern';

import {isNil} from 'ramda';

import {GetServiceOrderJobItemWorkApiResponse} from '@dms/api/workshop';
import {getDecimalFromPercentage} from '@dms/shared';

import {Nullish} from 'shared/web';

const MANUAL_DISCOUNT_SOURCE_TYPE = 'manual-discount';

interface GetItemPriceDiscountRateParams {
  isCustomDiscount: boolean | Nullish;
  discountType: string | Nullish;
  discountRate: number | Nullish;
  itemData: GetServiceOrderJobItemWorkApiResponse | Nullish;
}

/**
 * Resolves the decimal discount rate fed to the live price preview.
 * Manual discounts come from the form input (percentage), every other source
 * type reads its rate from the originally loaded item.
 */
export const getItemPriceDiscountRate = (params: GetItemPriceDiscountRateParams) =>
  match([params.isCustomDiscount, params.discountType])
    .with([false, Pattern.any], () => 0)
    .with([true, MANUAL_DISCOUNT_SOURCE_TYPE], () => getDecimalFromPercentage(params.discountRate))
    .with([true, Pattern.any], () => {
      const rate = params.itemData?.discount?.availableDiscounts?.find(
        (discount) => discount?.sourceType === params.discountType
      )?.rate;

      return isNil(rate) ? 0 : rate;
    })
    .otherwise(() => 0);
